<template>
<div id="xinxi" class="xinxi">
	<el-dialog title="申请修改" :visible.sync="approvalDialogFormVisible">
	  	<el-form >
	  	  	<el-form-item label="申请原因" label-width="80px">
	  	  	  	<el-input type="textarea" v-model="approval_add_reason" autocomplete="off"></el-input>
	  	  	</el-form-item>
	  	</el-form>
	  	<div slot="footer" class="dialog-footer">
	  	  	<el-button @click="approvalDialogFormVisible = false">取 消</el-button>
	  	  	<el-button type="primary" @click="approval_add()">确 定</el-button>
	  	</div>
	</el-dialog>
	<el-dialog title="学籍异动" :visible.sync="majorsDialogFormVisible">
	  	<el-form>
			<el-form-item label="异动专业" label-width="80px">
				<el-select v-model="approval_majors_grade_id" placeholder="请选择">
  					<el-option
  						v-for="item in approval_majors_arr"
  						:key="item.grade_id"
  						:label="item.major_name"
  						:value="item.grade_id">
  					</el-option>
  				</el-select>
	  	  	</el-form-item>
			<el-form-item label="附件" label-width="80px">
				<el-button type="primary" @click="selectImage1('file')">点击上传</el-button>
				<input type="file" ref="file" @change="change1($event,'file')" v-show="false"/>
				<div class="attachments_list">
					<div v-for="(item,i) in attachments" class="attachment" :key="i">
						{{ item.title }}
						<span class="delete" @click="attachment_delete(i,'file')">×</span>
					</div>
				</div>
	  	  	</el-form-item>
	  	  	<el-form-item label="申请原因" label-width="80px">
	  	  	  	<el-input type="textarea" v-model="approval_majors_reason" autocomplete="off"></el-input>
	  	  	</el-form-item>
	  	</el-form>
	  	<div slot="footer" class="dialog-footer">
	  	  	<el-button @click="majorsDialogFormVisible = false">取 消</el-button>
	  	  	<el-button type="primary" @click="add_relation_change()">确 定</el-button>
	  	</div>
	</el-dialog>
	<el-dialog title="前置学历" :visible.sync="userRelationFilesFormVisible">
	  	<el-form>
			<el-form-item label="文件类型" label-width="80px">
				<el-select v-model="user_relation_files_data.type" placeholder="请选择">
  					<el-option
  						v-for="item in $store.state.const.user_relation_files.type"
  						:key="item.id"
  						:label="item.value"
  						:value="item.id">
  					</el-option>
  				</el-select>
	  	  	</el-form-item>
			<el-form-item label="附件" label-width="80px">
				<el-button type="primary" @click="selectImage1('front_file')">点击上传</el-button>
				<input type="file" ref="front_file" @change="change1($event,'front_file')" v-show="false"/>
				<div class="attachments_list">
					<div v-for="(item,i) in user_relation_files_data.attachments" class="attachment" :key="i">
						{{ item.title }}
						<span class="delete" @click="attachment_delete(i,'front_file')">×</span>
					</div>
				</div>
	  	  	</el-form-item>
	  	  	<el-form-item label="备注" label-width="80px">
	  	  	  	<el-input type="textarea" v-model="user_relation_files_data.remark" autocomplete="off"></el-input>
	  	  	</el-form-item>
	  	</el-form>
	  	<div slot="footer" class="dialog-footer">
	  	  	<el-button @click="userRelationFilesFormVisible = false">取 消</el-button>
	  	  	<el-button type="primary" @click="post_user_relation_files()">确 定</el-button>
	  	</div>
	</el-dialog>
	<el-dialog title="修改密码" :visible.sync="dialogFormVisible">
		<el-form :model="ruleForm" :rules="pwdRules" ref="ruleForm">
			<el-form-item label="身份证" prop="idcardInput" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.idcardInput" autocomplete="off" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="pass" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.pass" type="password" autocomplete="off" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth">
				<el-input v-model="ruleForm.checkPass" type="password" autocomplete="off" placeholder="暂无填写" @paste.native.capture.prevent="false"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		</div>
	</el-dialog>
    <div class="uinfo">
		<div class="picture">
			<div class="photo" v-if="ruleForm.profile.entrance_pic">
				<div class="upload_photo">
					<img :src="global.oss_link+ruleForm.profile.entrance_pic">
				</div>
				
				<div class="photo_title">入学照片</div>
			</div>
			<div class="photo" v-if="ruleForm.profile.graduate_pic">
				<div class="upload_photo">
					<img :src="global.oss_link+ruleForm.profile.graduate_pic">
				</div>
				<div class="photo_title">毕业照片</div>
			</div>
		</div>
        <div class="titBox">
            <p class="tit">基本信息</p>
			<!-- <el-button class="edit_btn" type="primary" v-if="foundation_data_disabled" @click="foundation_data_disabled=false" size="mini">编辑</el-button>
			<el-button class="edit_btn" type="danger" v-if="!foundation_data_disabled" @click="foundation_data_disabled=true" size="mini">取消</el-button>
			<el-button class="edit_btn" type="primary" @click="foundation_save()" v-if="!foundation_data_disabled" size="mini">保存</el-button> -->
        </div>
	    <el-form :model="ruleForm" ref="ruleForm" class="uinfoForm">
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">学生姓名</label>
	    		<el-input v-model="ruleForm.profile.nick_name" disabled type="text" name="uname" id="uname" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">性别</label>
	    		<el-input v-model="ruleForm.sex" type="text" disabled name="sex" id="sex" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">出生日期</label>
	    		<el-input v-model="ruleForm.profile.birthday" disabled type="text" name="birthDate" id="birthDate" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">手机号码</label>
	    		<el-input v-model="ruleForm.profile.mobile" :disabled="foundation_data_disabled" type="text" name="phone" id="phone" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<!-- <el-form-item class="lineInput">
                <label class="labelTit">最高学历</label>
	    		<el-input v-model="ruleForm.xueli" type="text" name="xueli" id="xueli" placeholder="暂无填写"></el-input>
	    	</el-form-item> -->
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">证件类型</label>
	    		<el-input v-model="ruleForm.idcardType" disabled type="text" name="idcardType" id="idcardType" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">证件号码</label>
	    		<el-input v-model="ruleForm.profile.idcard" disabled type="text" name="idcard" id="idcard" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
	    		<label class="labelTit">政治面貌</label>
	    		<el-input v-model="ruleForm.profile.polit_face" :disabled="foundation_data_disabled" type="text" name="mianmao" id="mianmao" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">民族</label>
	    		<el-input v-model="ruleForm.profile.nation" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">户籍</label>
	    		<el-input v-model="ruleForm.profile.household_register" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input>
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">是否华侨</label>
				<el-select v-model="ruleForm.profile.is_overseas_chinese" :disabled="foundation_data_disabled" placeholder="请选择">
  					<el-option
  						v-for="item in correct_deny_arr"
  						:key="item.value"
  						:label="item.label"
  						:value="item.value">
  					</el-option>
  				</el-select>
	    		<!-- <el-input v-model="ruleForm.is_overseas_chinese_text" disabled type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">是否港澳台</label>
				<el-select v-model="ruleForm.profile.is_gangaotai" :disabled="foundation_data_disabled" placeholder="请选择">
  					<el-option
  						v-for="item in correct_deny_arr"
  						:key="item.value"
  						:label="item.label"
  						:value="item.value">
  					</el-option>
  				</el-select>
	    		<!-- <el-input v-model="ruleForm.is_gangaotai_text" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	    	</el-form-item>
	    	<el-form-item class="lineInput">
                <label class="labelTit">是否残疾</label>
				<el-select v-model="ruleForm.profile.is_disability" :disabled="foundation_data_disabled" placeholder="请选择">
  					<el-option
  						v-for="item in correct_deny_arr"
  						:key="item.value"
  						:label="item.label"
  						:value="item.value">
  					</el-option>
  				</el-select>
	    		<!-- <el-input v-model="ruleForm.is_disability_text" :disabled="foundation_data_disabled" type="text" name="minzu" id="minzu" placeholder="暂无填写"></el-input> -->
	    	</el-form-item>
        </el-form>
    </div>
	<div class="qianzhixueliInfo">
		<div class="titBox">
            <p class="tit">前置学历</p>
			<el-button class="edit_btn" type="primary" @click="user_relation_files_open()" size="mini">上传文件</el-button>
        </div>
		<div class="relation_table">
			<el-table :data="user_relation_files_list" stripe header-cell-class-name="paper_tab_head" v-loading="files_table_loading" border>
				<el-table-column align="center" class-name="title" label="标题" width="180">
        	        <template slot-scope="scope">
        	            {{scope.row.attachment.title}}
					</template>
				</el-table-column>
				<el-table-column prop="upload_at" align="center" class-name="title" label="上传时间" width="180"></el-table-column>
				<el-table-column align="center" class-name="title" label="审核状态" width="180">
					<template slot-scope="scope">
        	            {{ get_const_txt(scope.row.status) }}
					</template>
				</el-table-column>
				<el-table-column prop="audit_at" align="center" class-name="title" label="审核时间" width="180"></el-table-column>
				<el-table-column prop="audit_remark" align="center" class-name="title" label="审批反馈"></el-table-column>
        	    <el-table-column prop="termTxt" align="center" label="操作" width="120">
        	        <template slot-scope="scope">
        	            <el-button type="text" size="small" @click="view_file(scope.row.attachment.url)">查看</el-button>
						<el-button type="text" size="small" v-if="scope.row.status==5" disabled>删除</el-button>
						<el-button type="text" size="small" v-else @click="delete_file(scope.row.id)">删除</el-button>
        	        </template>
        	    </el-table-column>
			</el-table>
		</div>
		
	</div>
    <div class="xuejiInfo" v-if="hideType === 3">
        <div class="titBox">
            <p class="tit">学籍资料</p>
			<el-button class="edit_btn" type="primary" @click="apply_for_unusual_change()" size="mini">申请学籍异动</el-button>
			<!-- <div class="titRightBox">
				<el-button class="yidong" plain>申请学籍异动</el-button>
			</div> -->
        </div>
		<el-form :model="ruleForm" ref="ruleForm" class="xuejiForm" disabled>
			<el-form-item class="lineInput">
				<label class="labelTit">报考学校</label>
				<el-input v-model="ruleForm.school.school_name" type="text" name="school" id="school" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">年级</label>
				<el-input v-model="ruleForm.grade.grade_name" type="text" name="nian" id="nian" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学历层次</label>
				<el-input v-model="ruleForm.cengci" type="text" name="cengci" id="cengci" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">报考专业</label>
				<el-input v-model="ruleForm.major.major_name" type="text" name="zhuanye" id="zhuanye" placeholder="暂无填写"></el-input>
			</el-form-item> 
			<el-form-item class="lineInput">
				<label class="labelTit">班级</label>
				<el-input v-model="ruleForm.grade.class_name" type="text" name="banji" id="banji" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学号</label>
				<el-input v-model="ruleForm.student_sn" type="text" name="xuehao" id="xuehao" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学制</label>
				<el-input v-model="ruleForm.edu_system" type="text" name="xuezhi" id="xuezhi" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">学籍状态</label>
				<el-input v-model="ruleForm.xuejiSt" type="text" name="xuejiSt" id="xuejiSt" placeholder="暂无填写"></el-input>
			</el-form-item>
			<!-- <el-form-item class="lineInput">
				<label class="labelTit">教学点</label>
				<el-input v-model="ruleForm.org.name" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
			</el-form-item>
			<el-form-item class="lineInput">
				<label class="labelTit">校区</label>
				<el-input v-model="ruleForm.market.place_name" type="text" name="area" id="area" placeholder="暂无填写"></el-input>
			</el-form-item> -->
			<!-- <el-form-item class="lineInput">
				<label class="labelTit">异动审核状态</label>
				<el-input disabled v-model="ruleForm.yidong" type="text" name="yidong" id="yidong" placeholder="暂无填写"></el-input>
			</el-form-item> -->
        </el-form>
    </div>
    <div class="line wx_bind" v-if="wx_name">
		<div class="leftCon">
			<i class="iconfont">&#xe607;</i>
			<h2>微信绑定</h2>
			<span class="wx_name">{{wx_name}}</span>
		</div>
		<div class="rightCon">
			<p class="remove_bind" @click="remove_bind">解除绑定</p>
		</div>
    </div>
	<div @click="open_attestation" class="line pwdChange" v-if="ruleForm.is_certified==1&&temp.attestation">
		<div class="leftCon">
			<i class="iconfont">&#xec4d;</i>
			<h2>实名认证</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
		<span class="text_data" v-if="ruleForm.certified">{{'当前实名'+encryption(ruleForm.idcard)}}</span>
    </div>
    <div @click="dialogFormVisible = true" class="line pwdChange">
		<div class="leftCon">
			<i class="iconfont">&#xe609;</i>
			<h2>修改密码</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
    <div @click="jump_purchased" class="line purchased" v-if="temp.purchased">
		<div class="leftCon">
			<i class="iconfont">&#xe677;</i>
			<h2>已购课程</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
    <div @click="jump_logs" class="line logs">
		<div class="leftCon">
			<i class="iconfont">&#xe678;</i>
			<h2>操作日志</h2>
		</div>
        <i class="iconfont rightIcon">&#xe610;</i>
    </div>
</div>
</template>

<script>
function xuejiTxt(ji){
	switch (ji){
		case 1:
			return "在读"
		case 2:
			return "毕业"
		case 3:
			return "停学"
		case 4:
			return "退学"
	}
}
export default {
	name: 'index'
	,props:["userIndex"]
	,data () {
		// var checkAge = (rule, value, callback) => {
		// 	if (!value) {
		// 		return callback(new Error('年龄不能为空'));
		// 	}
		// 	setTimeout(() => {
		// 		if (!Number.isInteger(value)) {
		// 			callback(new Error('请输入数字值'));
		// 		} else {
		// 			if (value < 18) {
		// 				callback(new Error('必须年满18岁'));
		// 			} else {
		// 				callback();
		// 			}
		// 		}
		// 	}, 1000);
		// };
		var validatePass = (rule, value, callback) => {
			// console.log(value);
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
			if (value === '' || value === undefined) {
				callback(new Error('请输入密码'));
			} else if (!pwdReg.test(value)) {
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			// console.log(value);
			if (value === '' || value === undefined) {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
      		temp: this.temp.userCenter.index,
			ruleForm: {
				profile:{},
				grade:{},
				major:{},
				market:{},
				mould:{},
				school:{},
				org:{},
				uname: '',
				uphone: '',
				area: '',
				email: '',
				school: '',
				grade: '',
				cengci: '',
				zhuanye: '',
				idcard:'',
				idcardInput:'',
				pass:'',
				checkPass:'',
				certified:false, //是否已经实名认证
				is_certified:2, //是否开启实名认证
			},
			wx_name:'',
			pwdRules:{
				//required：是否必填，message错误提示内容，trigger触发方式
				idcardInput: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
				],
				pass: [
					// { required: true, message: '请输入新密码', trigger: 'blur' },
					{ validator: validatePass, required: true, trigger: 'blur' },
				],
				checkPass: [
					// { required: true, message: '请再次输入密码', trigger: 'blur' },
            		{ validator: validatePass2, required: true, trigger: 'blur' },
				],
			},
			dialogFormVisible: false,
			formLabelWidth: '120px',
			correct_deny_arr:[{label:'是',value:1},{label:'否',value:2}],
			foundation_data_disabled:true,
			approvalDialogFormVisible:false,
			approval_add_reason:'',
			approval_majors_arr:[],
			majorsDialogFormVisible:false,
			approval_majors_reason:'',
			approval_majors_grade_id:'',
			attachments:[],
			//前置学历参数
			userRelationFilesFormVisible:false,
			user_relation_files_data:{
				attachments:[],
				type:1,
				remark:''
			},
			user_relation_files_list:[],
			files_table_loading:false,
		}
	}
	,mounted:function(){
		var that = this
		this.$selfjs.getUserCallFn(this, function(res){
			let idcard = res.idcard,
				idcardType = '身份证'
			// that.ruleForm.uname=res.nick_name					//学生姓名
			// that.ruleForm.sex=that.$selfjs.getSex(idcard)	//性别
			// that.ruleForm.birthDate=that.$selfjs.getBirth(idcard)	//出生日期
			// that.ruleForm.uphone=res.mobile						//手机号码
			// that.ruleForm.xueli=res.max_education				//最高学历
			// that.ruleForm.area=res.student_from					//校区
			that.ruleForm.idcard=idcard						//证件号码
			that.wx_name=res.wx_name						//微信昵称
			that.unionid=res.unionid						//微信unionid
			if(idcard.length <= 15){
				idcardType = '其他'
			}
			// that.ruleForm.idcardType = idcardType					//证件类型
			// that.ruleForm.mianmao=res.polit_face				//政治面貌
			// that.ruleForm.minzu=res.nation						//民族
			// // that.ruleForm.email=res.email
			// that.ruleForm.school=res.school.school_name			//报考学校
			// that.ruleForm.nian=res.grade.grade_name				//年级
			// that.ruleForm.cengci=that.$store.state.const.major_level.find(v=>{ return v.id == res.major.major_level}).value		//学历层次
			// that.ruleForm.zhuanye=res.major.major_name			//报考专业
			// that.ruleForm.banji=res.grade.grade_name			//班级
			// that.ruleForm.xuehao=res.student_sn					//学号
			// that.ruleForm.xuezhi=res.student_system				//学制
			// that.ruleForm.xuejiSt=xuejiTxt(res.student_status)			//学籍状态
			that.ruleForm.yidong=res.yidong || "未申请"	//异动审核状态
			that.ruleForm.certified = res.certified
			that.ruleForm.is_certified = res.school.is_certified
			that.$store.dispatch('get_const').then((res)=>{
				that.get_my_user_relation()
			})
			
		})
	}
	,methods:{
		// 修改密码
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var token=this.$cookies.get("token")
						,that=this
					const url = this.global.serverSrc+this.global.qianzui+'/password/reset';
					// return false
					//发送修改密码请求
					this.$ajax.post(url,
						that.$qs.stringify({
							mobile:that.ruleForm.idcardInput
							,password: that.$selfjs.getAES(that.ruleForm.pass)
						})
					)
					.then(function(res){
						let resData=res.data;
						if(resData.code==0){
							//弹出即将退出登录的提示框
							that.$alert('修改密码成功，点击确定退出登录状态！！！', '信息提示', {
								confirmButtonText: '确定',
								callback: action => {
									that.$selfjs.loginOUtFn(that, "location")
								}
							});
							that.$message.close();
						}else{
							that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 已购课程跳转
		jump_purchased(){
			this.$emit('jump',['/web/purchased/', 'purchased'])
		},
		// 操作日志跳转
		jump_logs(){
			this.$emit('jump',['/web/logs', 'logs'])
		},
		//实名认证跳转
		open_attestation(){
			// if (!this.ruleForm.certified) {
				this.$emit('jump',['/web/name_attestation/', 'name_attestation'])
			// }
		},
		//微信解绑
		remove_bind(){
			let that = this
			const loading = this.$loading({
          		lock: true,
          		text: 'Loading',
          		spinner: 'el-icon-loading',
          		background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(
				this.global.serverSrc+this.global.qianzui+'/login/wechat_unbundling'
				,this.$qs.stringify({
					unionid:this.unionid
				})
			)
			.then(function (res){
				let resData=res.data;
				if(resData.code==0){
					that.$message({
						message: '微信解绑成功',
						type: 'success'
					});
					that.unionid = ''
					that.wx_name = ''
				}else{
					that.$message.error(resData.message)
				}
				loading.close();
			}).catch(function (res){
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//身份证脱敏
		encryption(text){
			if (text) {
				return text.replace(/(.{3}).*(.{3})/,"$1******$2")
			}
			
		},
		//获取我的详情
		get_my_user_relation(){
			this.$ajax.get(
				this.global.serverSrc + this.global.qianzui + '/user_relation/my'
			)
			.then((res)=>{
        	    let resData = res.data
				if(resData.code==0){
					this.ruleForm.idcardType = '身份证'
					this.ruleForm = Object.assign(this.ruleForm ,resData.data)
					if(this.ruleForm.profile.idcard.length <= 15){
						this.ruleForm.idcardType = '其他'
					}
					this.ruleForm.cengci=this.$store.state.const.major_level.find(v=>{ return v.id == this.ruleForm.major.major_level}).value
					this.ruleForm.xuejiSt=xuejiTxt(this.ruleForm.student_status)
					this.ruleForm.sex = '保密'
					if (this.ruleForm.profile.gender!=0) {
						this.ruleForm.sex = this.ruleForm.profile.gender==1?'男':'女'
					}
					// this.ruleForm.sex=this.$selfjs.getSex(this.ruleForm)
					this.ruleForm.is_overseas_chinese_text = this.ruleForm.profile.is_overseas_chinese==1?'是':'否'
					this.ruleForm.is_disability_text = this.ruleForm.profile.is_disability==1?'是':'否'
					this.ruleForm.is_gangaotai_text = this.ruleForm.profile.is_gangaotai==1?'是':'否'
					// console.log(resData.data);
					if (!this.ruleForm.org) {
						this.ruleForm.org = {}
					}
					this.get_majors()
					this.get_user_relation_files()
					// console.log(this.ruleForm);
					
					
        	        // this.select_number = resData.data.max_select_course_count
        	    } 
			})
		},
		//点击保存
		foundation_save(){
			this.$confirm('此操作将把修改的数据提交审核，是否继续?', '提示', {
        	  	confirmButtonText: '确定',
        	  	cancelButtonText: '取消',
        	  	type: 'warning'
        	}).then(() => {
        	  this.approval_add_reason = ''
			  this.approvalDialogFormVisible = true
        	}).catch(() => {
        	//   this.$message({
        	//     type: 'info',
        	//     message: '已取消删除'
        	//   });          
        	});
		},
		//基础信息修改
		approval_add(){
			let add_data = {
				relation_id:this.ruleForm.id,
				mobile:this.ruleForm.profile.mobile,
				polit_face:this.ruleForm.profile.polit_face,
				nation:this.ruleForm.profile.nation,
				household_register:this.ruleForm.profile.household_register,
				is_overseas_chinese:this.ruleForm.profile.is_overseas_chinese,
				is_gangaotai:this.ruleForm.profile.is_gangaotai,
				is_disability:this.ruleForm.profile.is_disability,
				reason:this.approval_add_reason
			}
			if (this.approval_add_reason=='') {
				this.$message.error('请填写申请理由！');
				return false
			}
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
        	this.$ajax.post(
				this.global.serverSrc + this.global.qianzui + '/approval/add',
        	    this.$qs.stringify(add_data)
			).then((res)=>{
        	    loading.close()
				let resData = res.data
				if(resData.code==0){
        	        this.$message.success('申请成功！');
					this.approvalDialogFormVisible = false
					this.foundation_data_disabled = true
				}
			}).catch(()=> {
        	    loading.close()
				this.$alert('申请异常', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//获取可异动的专业
		get_majors(){
			this.$ajax.get(
				this.global.serverSrc + this.global.qianzui + '/approval/majors',
				{
		    		params: {relation_id:this.ruleForm.id}
		    	}
			)
			.then((res)=>{
        	    let resData = res.data
				if(resData.code==0){        
					this.approval_majors_arr = resData.data            
        	        // this.select_number = resData.data.max_select_course_count
        	    } 
			})
		},
		//点击申请异动
		apply_for_unusual_change(){
			this.approval_majors_reason = ''
			this.approval_majors_grade_id = ''
			this.attachments = []
			this.majorsDialogFormVisible = true
		},
		//学籍异动审核
		add_relation_change(){
			let add_data = {
				relation_id:this.ruleForm.id,
				grade_id:this.approval_majors_grade_id,
				reason:this.approval_majors_reason,
				attachments:this.attachments
			}
			if (this.approval_majors_grade_id=='') {
				this.$message.error('请选择需要修改的班级！');
				return false
			}
			if (this.approval_majors_grade_id==(this.ruleForm.grade?this.ruleForm.grade.grade_id:'')) {
				this.$message.error('你已经在此班级，无需再申请！');
				return false
			}
			if (this.approval_majors_reason=='') {
				this.$message.error('请填写申请理由！');
				return false
			}
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
        	this.$ajax.post(
				this.global.serverSrc + this.global.qianzui + '/approval/add_relation_change',
        	    this.$qs.stringify(add_data)
			).then((res)=>{
        	    loading.close()
				let resData = res.data
				if(resData.code==0){
        	        this.$message.success('申请成功！');
					this.majorsDialogFormVisible = false
				}
			}).catch(()=> {
        	    loading.close()
				this.$alert('申请异常', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		selectImage1(file_txt){
            this.$refs[file_txt].click();
        },
        change1(event,file_txt) {
            let file = event.target.files[0];
            this.imgChange(file,file_txt)
        },
        // 上传阿里云
        async imgChange (file,file_txt) {
            // console.log(file);
            let that = this
            if(file==undefined){return false}
            if(file.size > 104857600){
				this.$alert('文件大小不能超过100MB', '信息提示', {
					confirmButtonText: '确定'
				})
                return false
			}
            const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
            //验证通过，上传文件
            let flname = this.$selfjs.createOssFileName()
			let upload_path = `xuexi.qsxueli.com/uploadFile/approval_audit/${flname}.${file.name.substring(file.name.lastIndexOf(".")+1)}`;
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/approval_audit'}))
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file, file.name);
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						loading.close()
						// console.log(res);
						if (res.ok) {
							if (file_txt=='file') {
								this.attachments.push({
                            	    title: file.name.substring(0, file.name.lastIndexOf(".")),
	        	            	    url: upload_path
                            	})	
							}else if (file_txt=='front_file') {
								this.user_relation_files_data.attachments.push({
                            	    title: file.name.substring(0, file.name.lastIndexOf(".")),
	        	            	    url: upload_path
                            	})	
							}
                            // that.imgsrc1 = that.global.oss_link+upload_path
                            this.$message.success('上传成功')
                            // console.log(that.attachment);
						}else{
							this.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
						}
					})
				}else{
                    loading.close()
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					this.$message.error(resData.message)
				}
		    }).catch(_ => {
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
        },
		//删除附件
		attachment_delete(i,file_txt){
			if (file_txt=='file') {
				this.attachments.splice(i, 1)
			}else if(file_txt=='front_file'){
				this.user_relation_files_data.attachments.splice(i, 1)
			}
			
		},
		//点击上传前置学历文件
		user_relation_files_open(){
			this.user_relation_files_data={
				attachments:[],
				type:1,
				remark:''
			}
			this.userRelationFilesFormVisible = true
		},
		//获取前置学历文件列表
		get_user_relation_files(){
			this.files_table_loading = true
			this.$ajax.get(this.global.serverSrc + this.global.qianzui +"/user_relation_files",
				{
		    		params: {limit:999,user_relation_id:this.ruleForm.id}
		    	}
			)
			.then((res)=>{
				let resData=res.data;
				this.files_table_loading = false
				if(resData.code==0){
					this.user_relation_files_list = resData.data.data
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
		},
		//前置学历文件保存
		post_user_relation_files(){
			let add_data = this.user_relation_files_data
			add_data.relation_id = this.ruleForm.id
			if (!add_data.attachments.length) {
				this.$message.error('请选择需要上传的文件！');
				return false
			}

			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
        	this.$ajax.post(
				this.global.serverSrc + this.global.qianzui + '/user_relation_files',
        	    this.$qs.stringify(add_data)
			).then((res)=>{
        	    loading.close()
				let resData = res.data
				if(resData.code==0){
					this.get_user_relation_files()
        	        this.$message.success('保存成功！');
					this.userRelationFilesFormVisible = false
				}
			}).catch(()=> {
        	    loading.close()
				this.$alert('保存异常', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
		},
		//查看文件
		view_file(url){
			window.open(this.global.oss_link+url)
		},
		//获取常量名称
		get_const_txt(id){
			return this.$store.state.const.user_relation_files.status.find(v=>{return v.id == id}).value
		},
		//删除前置学历文件
		delete_file(id){
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        	  	confirmButtonText: '确定',
        	  	cancelButtonText: '取消',
        	  	type: 'warning'
        	}).then(() => {
				const loading = this.$loading({
        		  	lock: true,
        		  	text: 'Loading',
        		  	spinner: 'el-icon-loading',
        		  	background: 'rgba(0, 0, 0, 0.7)'
        		});
        		this.$ajax.delete(
					this.global.serverSrc + this.global.qianzui + '/user_relation_files/'+id,
				).then((res)=>{
        		    loading.close()
					let resData = res.data
					if(resData.code==0){
						this.get_user_relation_files()
        		        this.$message.success('删除成功！');
					}
				}).catch(()=> {
        		    loading.close()
					this.$alert('删除异常', '信息提示', {
						confirmButtonText: '确定',
					});
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
        	}).catch(() => {        
        	});
		}
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/userCenter/index.vue